import React from 'react'

function ButtonLink({ click, title }) {
    return (
        <>
            <a onClick={click} className="btn btn-link text-right text-success pr-0">{title}</a>
        </>
    )
}

export default ButtonLink
